var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"directory-display"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"page-header"},[_c('button',{staticClass:"btn btn-primary btn-lg float-right my-1 mx-1",on:{"click":function($event){return _vm.newAuthorityContact()}}},[_c('i',{staticClass:"fa fa-plus fa-fw mr-2"}),_vm._v(" Add New Contact\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8944268","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/DirectoryDisplay.vue
// module id = 1396
// module chunks = 1